export function getSuggestions({ recipes, pantryItems, currentWeekMeals, recentWeeks }) {
  const plannedNames = new Set();
  if (currentWeekMeals) {
    for (const day of Object.values(currentWeekMeals)) {
      for (const slots of Object.values(day)) {
        const slotsArr = Array.isArray(slots) ? slots : (slots ? [slots] : []);
        for (const slot of slotsArr) {
          if (slot.name?.trim()) plannedNames.add(slot.name.toLowerCase().trim());
        }
      }
    }
  }

  const pantryStock = {};
  if (Array.isArray(pantryItems)) {
    for (const item of pantryItems) {
      if (item.name) pantryStock[item.name.toLowerCase().trim()] = item.qty || 0;
    }
  }

  // Pantry-based: score recipes by how many ingredients are in stock
  const pantryBased = (recipes || [])
    .map((recipe) => {
      const ings = recipe.ingredients || [];
      if (ings.length === 0) return null;
      const inStock = ings.filter((ing) => {
        const key = ing.name?.toLowerCase().trim();
        return key && (pantryStock[key] || 0) > 0;
      }).length;
      const score = inStock / ings.length;
      if (score < 0.5) return null;
      return { ...recipe, score, inStock, totalIngredients: ings.length };
    })
    .filter(Boolean)
    .filter((r) => !plannedNames.has(r.name.toLowerCase().trim()))
    .sort((a, b) => b.score - a.score)
    .slice(0, 5);

  // Favorites: bookmarked recipes first, then frequently cooked meals
  const frequency = {};
  for (const weekData of (recentWeeks || [])) {
    const meals = weekData.meals || weekData;
    for (const day of Object.values(meals)) {
      for (const slots of Object.values(day || {})) {
        const slotsArr = Array.isArray(slots) ? slots : (slots ? [slots] : []);
        for (const slot of slotsArr) {
          if (slot.name?.trim()) {
            const key = slot.name.toLowerCase().trim();
            frequency[key] = (frequency[key] || 0) + 1;
          }
        }
      }
    }
  }

  // Start with bookmarked recipes
  const bookmarked = (recipes || [])
    .filter((r) => r.favorite && !plannedNames.has(r.name.toLowerCase().trim()))
    .map((r) => ({ name: r.name, count: frequency[r.name.toLowerCase().trim()] || 0, recipe: r }));

  // Then add frequently cooked meals that aren't already bookmarked
  const bookmarkedNames = new Set(bookmarked.map((b) => b.name.toLowerCase().trim()));
  const frequentMeals = Object.entries(frequency)
    .filter(([name]) => !plannedNames.has(name) && !bookmarkedNames.has(name))
    .sort((a, b) => b[1] - a[1])
    .slice(0, Math.max(0, 5 - bookmarked.length))
    .map(([name, count]) => {
      const recipe = (recipes || []).find((r) => r.name.toLowerCase().trim() === name);
      return { name: recipe ? recipe.name : name, count, recipe };
    });

  const favorites = [...bookmarked, ...frequentMeals].slice(0, 5);

  // Rotation: recipes not used in current week or last 2 recent weeks
  const recentNames = new Set();
  for (const weekData of (recentWeeks || []).slice(0, 2)) {
    const meals = weekData.meals || weekData;
    for (const day of Object.values(meals)) {
      for (const slots of Object.values(day || {})) {
        const slotsArr = Array.isArray(slots) ? slots : (slots ? [slots] : []);
        for (const slot of slotsArr) {
          if (slot.name?.trim()) recentNames.add(slot.name.toLowerCase().trim());
        }
      }
    }
  }
  const rotationPool = (recipes || []).filter((r) => {
    const key = r.name.toLowerCase().trim();
    return !plannedNames.has(key) && !recentNames.has(key);
  });
  // Shuffle and take 3
  const shuffled = rotationPool.slice().sort(() => Math.random() - 0.5);
  const rotation = shuffled.slice(0, 3);

  return { pantryBased, favorites, rotation };
}
